import { render } from "./sysTenantForm.vue?vue&type=template&id=0b1cfef1"
import script from "./sysTenantForm.vue?vue&type=script&lang=js"
export * from "./sysTenantForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__